import { forwardRef, TextareaHTMLAttributes } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type StepFormTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & PropsWithClassName;

const StepFormTextarea = forwardRef<HTMLTextAreaElement, StepFormTextareaProps>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'border border-[rgba(0,0,0,0.12)] bg-white rounded-xl px-4 py-3.5 font-dm text-sm text-black',
      'placeholder:text-[rgba(0,0,0,0.38)] outline-none focus:border-[rgba(0,0,0,0.3)] w-full min-h-[120px] resize-y',
      className
    )}
    {...props}
  />
));

StepFormTextarea.displayName = 'StepFormTextarea';

export default StepFormTextarea;
